module.exports = __webpack_public_path__ + "static/media/5.386f4d17.jpg";